// extracted by mini-css-extract-plugin
var _1 = "W_iAsfuMbV";
var _2 = "v3FrUNTdcJ";
var _3 = "ZyAOg9Vwyr";
var _4 = "vtTOHnNXZX";
export { _1 as "block", _2 as "box", _3 as "line", _4 as "underline" }
